module.exports = __webpack_public_path__ + "img/style-2.ff85e46b.jpg";